import { Navigate, useSearchParams } from 'react-router-dom';
import React, { FC, useEffect } from 'react';
import { NO_PROJECTS, REDIRECT_TO, SIGN_IN_ERROR } from '../../../config/constants';
import { client, getDefaultRoute } from '../../../services';
import { notification } from '../../../antdProvider';
import SessionStarter from '../SessionStarter';

interface Props {
  isLoading?: boolean
}

const RootRoute: FC<Props> = ({ isLoading }) => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get(SIGN_IN_ERROR);
    if (code === null) return;
    // Anyone can put text in this URL, so only a plain error code is shown
    const shownCode = /^[a-z_]{1,40}$/i.test(code) ? ` (${code})` : '';
    notification.warning({
      key: SIGN_IN_ERROR,
      message: 'Sign In Not Completed',
      description: `Signing in again failed${shownCode}. You're still signed in.`,
    });
  }, []);

  const requestedRoute = searchParams.get(REDIRECT_TO) || undefined;
  if (isLoading) {
    return <SessionStarter />;
  }

  const result = getDefaultRoute(requestedRoute);
  // A signed-in user with no project to open is sent to the login page, which must then
  // show itself instead of sending the stored session straight back here. The marker is
  // navigation state, which a link cannot set.
  if (result === '/login' && client.cache.current.auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ [NO_PROJECTS]: true }} />;
  }
  return <Navigate to={result} replace />;
};
export default RootRoute;
